import React from 'react'
import { connect } from 'react-redux'
import { getVehicleParts } from 'SRC/modules/vehicleParts/list/selectors'
import { getPagination } from 'SRC/modules/vehicleParts/list/selectors'
import { Links } from 'SRC/modules/common/components/Pagination'
import PropTypes from 'prop-types'

import useTranslation from 'next-translate/useTranslation'

import translations from '../../../../../../public/data/translations.json'

const VehicleParts = ({ paginationParams, products }) => {
  const { lang } = useTranslation('common')
  const locale = lang?.toUpperCase() || 'ME'

  if (paginationParams?.totalPages <= 1) return null

  const pageCount = Number(paginationParams.totalPages)
  if (pageCount === 0) return null

  const currentPage = Number(paginationParams.page)
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === pageCount
  const baseUrl = {
    href: { pathname: '/vehicleParts', query: {} },
    as: `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`
  }

  const buildAsUrl = (pageNumber) => `${baseUrl.as}?${new URLSearchParams({
    page: String(pageNumber)
  }).toString()}`

  const prevPageNumber = currentPage === 1 ? currentPage : currentPage - 1
  const prevUrl = {
    href: {
      pathname: baseUrl.href.pathname,
      query: {
        ...baseUrl.href.query,
        page: prevPageNumber
      }
    },
    as: buildAsUrl(prevPageNumber)
  }

  const nextPageNumber = currentPage === pageCount ? currentPage : currentPage + 1
  const nextUrl = {
    href: {
      pathname: baseUrl.href.pathname,
      query: {
        ...baseUrl.href.query,
        page: nextPageNumber
      }
    },
    as: buildAsUrl(nextPageNumber)
  }

  const pages = []

  for (let i = 1; i <= pageCount; i++) {
    pages.push({
      number: i,
      isCurrent: i === currentPage,
      href: {
        pathname: baseUrl.href.pathname,
        query: {
          ...baseUrl.href.query,
          page: i
        }
      },
      as: buildAsUrl(i)
    })
  }

  if (!products?.length) return null

  return (
    <div className='vehicle-parts-pagination'>
      <Links
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        prevUrl={prevUrl}
        nextUrl={nextUrl}
        pages={[...pages]}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  products: getVehicleParts(state),
  paginationParams: getPagination(state)
})

VehicleParts.propTypes = {
  products: PropTypes.array.isRequired,
  paginationParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
  }).isRequired
}

VehicleParts.defaultProps = {
  products: []
}

export default connect(mapStateToProps)(VehicleParts)
